import { Image } from "antd";
import { useState } from "react";
import {
    fiveMarlaImages,
    fourMarlaImages,
    apartmentImages,
    viewsImages,
} from "../../data/galleryData";

const FullGallery = ({ variant }) => {
    const [filter, setFilter] = useState(fiveMarlaImages);

    const handleFilterChange = (value) => {
        setFilter(value);
    };

    return (
        <div>
            <div className="font-poppins text-primary-gold text-2xl font-light flex justify-around flex-wrap pt-10 gap-y-5 gap-x-4">
                <div
                    className={`cursor-pointer ${
                        filter === fiveMarlaImages
                            ? "border-b-primary-gold border-b-2"
                            : "border-b-primary-white border-b-2"
                    }`}
                    onClick={() => handleFilterChange(fiveMarlaImages)}
                >
                    5 Marla
                </div>
                <div
                    className={`cursor-pointer ${
                        filter === fourMarlaImages
                            ? "border-b-primary-gold border-b-2"
                            : "border-b-primary-white border-b-2"
                    }`}
                    onClick={() => handleFilterChange(fourMarlaImages)}
                >
                    4 Marla
                </div>
                {variant === 1 && (
                    <div
                        className={`cursor-pointer ${
                            filter === viewsImages
                                ? "border-b-primary-gold border-b-2"
                                : "border-b-primary-white border-b-2"
                        }`}
                        onClick={() => handleFilterChange(viewsImages)}
                    >
                        Views
                    </div>
                )}
                <div
                    className={`cursor-pointer ${
                        filter === apartmentImages
                            ? "border-b-primary-gold border-b-2"
                            : "border-b-primary-white border-b-2"
                    }`}
                    onClick={() => handleFilterChange(apartmentImages)}
                >
                    Apartments
                </div>
            </div>
            <div className="w-full flex justify-center flex-wrap gap-3 sm:px-40 mt-14 mb-20">
                {filter.map((src, index) => (
                    <Image
                        key={index}
                        width={300}
                        height={300}
                        src={src}
                        style={{ zIndex: "1", objectFit: "cover"}}
                    />
                ))}
            </div>
        </div>
    );
};

export default FullGallery;
